import * as React from 'react';

const styles = {
    inputBox:{
        width: '90%',
        padding: '8px 17px',
        border: '2px solid grey',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px',
    },
};

interface Props {
    columns: any[];
    onSave: (row: any[]) => any[];
    onModalClose: () => any;
    validateState: {};
    ignoreEditable: boolean;
}

interface State {
    row: any;
    publisherPropositionType: String;
    fields: {};
    errors: {};
}

class PublisherInsertForm extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            row: {},
            publisherPropositionType: 'APP_INSTALL',
            fields: {},
            errors: {},
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }
    handleChange(event) {
        this.state.publisherPropositionType = event.target.value;
        this.state.row['propositionType'] = this.state.publisherPropositionType;
        this.setState({
            ...this.state,
        });
    }

    updateInputValue(event) {
        this.state.row[event.target.name] = event.target.value;
        this.setState({
            ...this.state,
        });
    }

    handleSaveBtnClick() {
        this.state.row['propositionType'] = this.state.publisherPropositionType;
        this.props.onSave(this.state.row);
    }

    handleValidation() {
        let fields = this.state.row;
        let errors = {};
        let formIsValid = true;

        let nameRegExp = new RegExp('^[a-z0-9A-Z_\\s]+$');
        if (!fields['displayName'] || !nameRegExp.test(fields['displayName'])) {
            formIsValid = false;
            errors['displayName'] = 'INVALID USER NAME';
        }
        if (!fields['name'] || !nameRegExp.test(fields['name'])) {
            formIsValid = false;
            errors['name'] = 'INVALID NAME';
        }


        let propositionsTypes = ['CTA_URL','APP_INSTALL','NO_PROPOSITION'];
        let packageNameRegExp = new RegExp('^((\\w+)(\\.))+(\\w+)$');
        let urlRegExp = new RegExp('^http(s)?://([\\w-]+\\.)+[\\w-]+(/[\\w- ./?%&amp;=]*)?$');

        if (fields['propositionType'] == 'APP_INSTALL') {
            if (!fields['url'] || !urlRegExp.test(fields['url'])) {
                formIsValid = false;
                errors['url'] = 'INVALID URL';
            }
            if (!fields['packageName'] || !packageNameRegExp.test(fields['packageName'])) {
                formIsValid = false;
                errors['packageName'] = 'INVALID PACKAGE NAME';
            }
        }
        if (fields['propositionType'] == 'CTA_URL') {
            if (!fields['url'] || !urlRegExp.test(fields['url'])) {
                formIsValid = false;
                errors['url'] = 'INVALID URL';
            }
        }

        this.setState({
            ...this.state,
            errors: errors,
        });
        return formIsValid;
    }

    render() {
        const {
            onModalClose,
            onSave,
            columns,
            validateState,
            ignoreEditable,
        } = this.props;

        return (
            <div className='modal-content'>
                <h2
                    style={{
                        marginLeft: '26%',
                        marginTop: '40px',
                        color: '#0dc1e5',
                    }}
                >
                    Insert New Row
                </h2>
                <div style={{ marginLeft: '20px', marginTop: '30px' }}>
                    {columns.map((column, i) => {
                        const {
                            editable,
                            format,
                            field,
                            name,
                            hiddenOnInsert,
                        } = column;

                        if (field == 'displayName' || field == 'name')
                            return (
                                <div className='form-group' key={field}>
                                    <label>{name} : </label>
                                    <br />
                                    <input
                                        style={styles.inputBox}
                                        value={this.state.row[field]}
                                        ref={field}
                                        type='text'
                                        defaultValue={''}
                                        name={field}
                                        onChange={this.updateInputValue.bind(
                                            this,
                                        )}
                                    />
                                    <br />
                                    <span style={{ color: 'red' }}>
                                        {this.state.errors[field]}
                                    </span>
                                </div>
                            );

                        if (field == 'propositionType')
                            return (
                                <div className='form-group' key={field}>
                                    <label>{name} : </label>
                                    <select
                                        style={{
                                            marginLeft: '20px',
                                            marginTop: '20px',
                                        }}
                                        value={this.state.row[field]}
                                        ref={field}
                                        name={field}
                                        onChange={this.handleChange}
                                    >
                                        <option value='CTA_URL'>CTA_URL</option>
                                        <option selected value='APP_INSTALL'>
                                            APP_INSTALL
                                        </option>
                                        <option value='NoProposition'>
                                            No Proposition
                                        </option>
                                    </select>
                                </div>
                            );

                        if (
                            this.state.publisherPropositionType == 'APP_INSTALL' &&
                            field == 'packageName'
                        )
                            return (
                                <div className='form-group' key={field}>
                                    <label>{name} : </label>
                                    <input
                                        style={styles.inputBox}
                                        value={this.state.row[field]}
                                        ref={field}
                                        type='text'
                                        name={field}
                                        defaultValue={''}
                                        onChange={this.updateInputValue}
                                    />
                                    <br />
                                    <span style={{ color: 'red' }}>
                                        {this.state.errors[field]}
                                    </span>
                                </div>
                            );
                        if (
                            (this.state.publisherPropositionType == 'APP_INSTALL' ||
                                this.state.publisherPropositionType == 'CTA_URL') &&
                            field == 'url'
                        )
                            return (
                                <div className='form-group' key={field}>
                                    <label>{name} : </label>
                                    <br />
                                    <input
                                        style={styles.inputBox}
                                        value={this.state.row[field]}
                                        ref={field}
                                        type='text'
                                        name={field}
                                        defaultValue={''}
                                        onChange={this.updateInputValue}
                                    />
                                    <br />
                                    <span style={{ color: 'red' }}>
                                        {this.state.errors[field]}
                                    </span>
                                </div>
                            );
                          if (field == 'logoUrl')
                            return (
                            <div className="form-group" key={field}>
                                <label>{name} : </label>
                                <br />
                                <input
                                style={styles.inputBox}
                                value={this.state.row[field]}
                                ref={field}
                                type="text"
                                name={field}
                                defaultValue={''}
                                onChange={this.updateInputValue}
                                />
                                <br />
                                <span style={{ color: 'red' }}>
                                {this.state.errors[field]}
                                </span>
                            </div>
                            );
                    })}
                </div>
                <div>
                    <button
                        style={{
                            marginTop: '30px',
                            marginBottom: '50px',
                            marginLeft: '30%',
                        }}
                        className='btn btn-danger'
                        onClick={onModalClose}
                    >
                        Cancel
                    </button>
                    <button
                        style={{
                            marginTop: '30px',
                            marginBottom: '50px',
                            marginLeft: '5%',
                        }}
                        className='btn btn-success'
                        onClick={() => this.handleSaveBtnClick()}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        );
    }
}

export default PublisherInsertForm;



// WEBPACK FOOTER //
// ./src/components/PublisherInsertForm.tsx